import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      {/* Header */}
      <header className="border-b border-amber/[0.08] bg-obsidian/95 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-5">
          <Link to="/" className="inline-flex items-center gap-2 text-amber hover:text-amber/80 transition-colors font-body text-sm">
            <ArrowLeft size={16} />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl md:text-5xl font-light text-ivory mb-4">Privacy Policy</h1>
        <p className="text-ivory/30 font-body text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 font-body text-ivory/70 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">1. Information We Collect</h2>
            <p className="mb-4">When you make a reservation with The Curated Experience, we collect the following information:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Full name</li>
              <li>Phone number</li>
              <li>Email address (optional)</li>
              <li>Booking preferences and special requests</li>
              <li>Payment information (processed securely via Razorpay)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">We use your personal information to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Process and confirm your bookings</li>
              <li>Communicate with you about your reservation via WhatsApp or phone</li>
              <li>Send booking confirmations and updates</li>
              <li>Improve our services and customer experience</li>
              <li>Handle any queries or special requests</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. Your payment information is securely processed by Razorpay and we do not store your card details on our servers.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">4. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information. All payment transactions are encrypted and processed through Razorpay's secure payment gateway.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">5. Cookies</h2>
            <p>Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">6. Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal data</li>
              <li>Request correction of your data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">7. Contact Us</h2>
            <p className="mb-2">If you have any questions about this Privacy Policy, please contact us:</p>
            <p className="text-amber">Email: support@tcexp.in</p>
            <p className="text-amber">Phone: +91 8876133284</p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-amber/[0.08] py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-ivory/30 font-body text-sm">© 2026 The Curated Experience. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
